<template>
  <div class="category">
    <HeroSecondary
      v-if="hero"
      :key="hero.heading || name"
      :heading="hero.heading || name"
      :image="hero.image"
    />
    <div class="category-container">
      <CategoryDescription
        v-if="description"
        :description="description"
      />
      <div class="don't remove me"/>
      <div class="court-wrapper">
        <CourtHalf
          expand
          class="court"
          side="top"
        />
      </div>
      <ul class="tiles">
        <template
          v-for="slug in programs"
        >
          <li
            :key="slug"
            class="tile"
          >
            <ProgramTile
              :slug="slug"
              :category="singularName"
            />
          </li>
          <li
            :key="`${slug}-court`"
            class="court-wrapper"
            aria-hidden="true"
          >
            <CourtHalf
              expand
              class="court"
              side="top"
            />
          </li>
        </template>
      </ul>
    </div>
    <CategoryLinks/>
  </div>
</template>

<script>
  import { fetchCategory, fetchPrograms } from '@/api/programs';

  import CourtHalf from './CourtHalf';
  import ProgramTile from './ProgramTile';
  import HeroSecondary from './HeroSecondary';
  import CategoryLinks from './CategoryLinks';
  import CategoryDescription from './CategoryDescription';

  export default {
    components: {
      CourtHalf,
      ProgramTile,
      HeroSecondary,
      CategoryLinks,
      CategoryDescription,
    },
    data() {
      return {
        name: undefined,
        hero: undefined,
        programs: undefined,
        description: undefined,
        singularName: undefined,
      };
    },
    watch: {
      $route: 'fetch',
    },
    created() {
      this.fetch();
    },
    methods: {
      cleanProgram({ slug }) {
        return slug;
      },
      cleanCategory(category) {
        const {
          id,
          name,
          acf: { hero, singular_name: singularName },
          description,
        } = category;

        return {
          id,
          name,
          hero,
          description,
          singularName,
        };
      },
      async fetchPrograms() {
        this.programs = (await fetchPrograms({ 'product-categories': this.id })).map(this.cleanProgram);
      },
      async fetch() {
        const {
          id,
          name,
          hero,
          description,
          singularName,
        } = this.cleanCategory(await fetchCategory(this.$route.params.category));

        this.id = id;
        this.name = name;
        this.hero = hero;
        this.description = description;
        this.singularName = singularName;

        this.fetchPrograms();

        this.$store.commit('setViewName', name);
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .category-container {
    max-width: $max-width;
    margin: spacing(base-delta) auto;
    padding-right: spacing(base-delta);
    padding-left: spacing(base-delta);

    @include breakpoint(phablet) {
      margin-top: spacing(base-eta);
      margin-bottom: spacing(base-eta);
      padding-right: spacing(base-epsilon);
      padding-left: spacing(base-epsilon);
    }
  }

  .court {
    color: color(bronze);
    margin-top: spacing(base-epsilon);
  }

  .court-wrapper {
    @include column;

    width: 100%;

    @include breakpoint(phablet) {
      &:nth-child(4n + 2) {
        display: none;
      }
    }
  }

  .tile {
    @include column;

    width: 100%;
    margin-top: spacing(base-epsilon);

    @include breakpoint(phablet) {
      width: 50%;
    }
  }

  .tiles {
    display: flex;
    flex-wrap: wrap;
  }
</style>
